import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, NavItem } from 'react-bootstrap';

import wingSvg from '../../images/wing.svg';
import { getLoggedInUser } from 'reducers';
import { logout } from 'actions/login';
import { can, permActions } from 'permissions';
import NavBarLink from './NavBarLink';
import NavBarUser from './NavBarUser';
import NavBarAtt from './NavBarAtt';
import NavBarQuick from './NavBarQuick';
import NavBarSimo from './NavBarSimo';

let NavBar = ({ loggedInUser, logout }) => {
  const userGroup = [
    { to: '/users', label: 'All Users' },
    { to: '/users/search', label: 'Search Users' },
    {
      to: '/users/new',
      permission: can(loggedInUser, permActions.VIEW_CREATE_USER),
      label: 'New User',
    },
    {
      to: '/device-protection/contracts',
      permission: can(loggedInUser, permActions.VIEW_DEVICE_PROTECTION_GROUP),
      label: 'All Device Protection Contracts',
    },
  ];

  const subsGroup = [
    { to: '/att/subscriptions', label: 'AT&T Subscriptions' },
    { to: '/att/subscriptions/search', label: 'Search AT&T Subs' },
    { to: 'divider1', divider: true },
    { to: '/quick/subscriptions', label: 'Quick Subscriptions' },
    { to: '/quick/subscriptions/search', label: 'Search Quick Subs' },
    { to: '/quick/pre-activation', label: 'Quick Pre-Activation' },
    { to: '/quick/port-outs', label: 'Quick Port Outs' },
    { to: 'divider2', divider: true },
    { to: '/simo/subscriptions', label: 'Simo Subscriptions' },
    { to: '/simo/subscriptions/search', label: 'Search Simo Subs' },
  ];

  const showSubsGroup = can(loggedInUser, permActions.VIEW_TOP_SUBS_GROUPS);
  const showFeedback = can(loggedInUser, permActions.VIEW_TOP_FEEDBACK);
  const showLogout = Boolean(loggedInUser.acl_group_name);

  const renderLinks = (links) =>
    links.map((link) => <NavBarLink key={link.to} {...link} />);

  return (
    <Navbar fixedTop collapseOnSelect>
      <Navbar.Header>
        <Navbar.Brand>
          <Link to="/">
            <img src={wingSvg} alt="Wing" />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        <Nav pullRight>
          <NavDropdown eventKey={3} title="User" id="user-nav">
            {renderLinks(userGroup)}
            <li>
              {/* eslint-disable-next-line */}
              <a href="#" onClick={logout}>
                Logout
              </a>
            </li>
            <NavBarUser />
          </NavDropdown>
          <NavDropdown eventKey={4} title="Subscription" id="sub-nav">
            {showSubsGroup && renderLinks(subsGroup)}
            <NavBarAtt />
            <NavBarSimo />
            <NavBarQuick />
          </NavDropdown>
          {showFeedback && (
            <NavItem
              href="https://docs.google.com/forms/d/e/1FAIpQLSeeH63s6f7-eVSstJmAEo3fSiXSzOa7XMX1Ib-2OYG8Ao02-Q/viewform"
              target="_blank"
              rel="noopener noreferrer"
              eventKey={6}
            >
              Submit Feedback
            </NavItem>
          )}
          {showLogout && (
            <NavItem onClick={logout} eventKey={7}>
              Logout
            </NavItem>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

const mapStateToProps = (state) => ({
  loggedInUser: getLoggedInUser(state),
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

NavBar = connect(mapStateToProps, mapDispatchToProps)(NavBar);

export default NavBar;
